/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
var Sword = function (quality) {
  return {
    slot: 'weapon',
    type: 'sword',
    quality: quality,
    damageMod: quality * 0.4,
    learning: Math.round(1 + quality * 2.5),
    strength: Math.round(1 + quality * 2.5),
  };
};
module.exports = Sword;
